import {currencyFormat} from "@/utils";

interface ReportCardProps {
  title: string
  total: number
  classNames: string
  isPlainText?: boolean
}

const ReportSummaryCard: React.FC<ReportCardProps> =
  ({
     title,
     total,
     classNames,
     isPlainText= false
   }) => (
    <div className={`w-full rounded-lg j-col py-6 px-14 sm:px-7 gap-2 border border-stroke-subtle ${classNames}`}>
      <div className="text-jbase font-normal whitespace-nowrap">{title}</div>
      <div className="text-jb-3xl whitespace-nowrap sm:text-xl">{isPlainText ? total : currencyFormat(total)}</div>
    </div>
  )

export default ReportSummaryCard;